import type {} from '@redux-devtools/extension'; // required for devtools typing
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { Timesheet } from '#/shared/types/Timesheet';
import { TimesheetApiLinks } from '#/shared/types/TimesheetApiModal';

export type SetTimesheetDataProps = {
  timesheet: Timesheet | null;
  links: TimesheetApiLinks | null;
};
interface TimesheetStore {
  timesheet: Timesheet | null;
  links: TimesheetApiLinks | null;
  setTimesheetData: (data: SetTimesheetDataProps) => void;
  resetVerification: () => void;
}

export const selectTimesheetIsVerified = (state: TimesheetStore): boolean =>
  Boolean(state.timesheet?.verifiedBy?.verifiedAt);

export const useTimesheetStore = create<TimesheetStore>()(
  devtools(
    (set): TimesheetStore => ({
      timesheet: null,
      links: null,
      setTimesheetData: ({ timesheet, links }) => set(() => ({ timesheet, links })),
      resetVerification: () =>
        set(state => {
          if (state.timesheet) {
            return {
              timesheet: { ...state.timesheet, verifiedBy: undefined },
              links: state.links,
            };
          }
          return state;
        }),
    }),
    {
      name: 'timesheet-storage',
    },
  ),
);
